export class Offer {
  constructor(
    public name: string,
    public price: number,
    public description: string,
    public refAdeme?: string,
    public address?: string,
    public promoCode?: string
  ) {}
}
